import { ROLE_CHILDREN_MAP } from "@/constants";
import { AppThunk, RootState } from "@/store";
import { RequestQueueItem } from "@/types/requestQueue";
import { isManagerRole } from "@/utils/business/isManagerRole";

import {
    addOrReplaceRequestQueueItem,
    addRequestQueueItem,
} from "./offline.slice";

type QueueItemPayload = Omit<
    RequestQueueItem,
    "status" | "createdAt" | "commandsRevision"
>;

const resolveQueueMetadata = (
    state: RootState,
    metadata?: RequestQueueItem["metadata"],
): RequestQueueItem["metadata"] => {
    const nextMetadata: RequestQueueItem["metadata"] = { ...metadata };

    const pointId = nextMetadata.pointId;
    const taskId = nextMetadata.taskId;

    if (pointId && !nextMetadata.pointName) {
        nextMetadata.pointName = state.work.points?.[pointId]?.name;
    }

    if (pointId && taskId && !nextMetadata.taskName) {
        nextMetadata.taskName = state.work.tasks?.[pointId]?.[taskId]?.name;
    }

    // Resolve performer user ID and role slug
    const loggedInUserRole = state.user.role;
    const loggedInUserId = state.user.id;
    const activeSchedule = state.manager.activeSchedule;
    const isManager = loggedInUserRole
        ? isManagerRole(loggedInUserRole)
        : false;

    const performerUserId = isManager ? activeSchedule?.userId : loggedInUserId;
    const performerRoleSlug =
        isManager && loggedInUserRole
            ? ROLE_CHILDREN_MAP[loggedInUserRole]
            : loggedInUserRole;

    if (performerUserId && performerRoleSlug) {
        nextMetadata.user = {
            userId: performerUserId,
            roleSlug: performerRoleSlug,
        };
    }

    return nextMetadata;
};

export const enqueueRequestQueueItem =
    (payload: QueueItemPayload): AppThunk =>
    (dispatch, getState) => {
        dispatch(
            addRequestQueueItem({
                ...payload,
                metadata: resolveQueueMetadata(getState(), payload.metadata),
            }),
        );
    };

export const enqueueOrReplaceRequestQueueItem =
    (payload: QueueItemPayload): AppThunk =>
    (dispatch, getState) => {
        dispatch(
            addOrReplaceRequestQueueItem({
                ...payload,
                metadata: resolveQueueMetadata(getState(), payload.metadata),
            }),
        );
    };
